import {EntityService} from '../../../service/EntityService';

export class CertGdtProcessingService extends EntityService {
  static entity = '/iam-system/cert-gdt-processing';

  static getGdtChecking(taxWithholdCertId: string, params?: any): Promise<any> {
    return this.axios.get(`${this.entity}/${taxWithholdCertId}/gdt-checking`, {params}).then(res => res.data);
  }

  static updateMessageId(taxWithholdCertId: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${taxWithholdCertId}/update-message-id`, data).then(res => res.data);
  }

  static resendCert(taxWithholdCertId: string, data?: any): Promise<any> {
    return this.axios.put(`${this.entity}/${taxWithholdCertId}/resend-cert`, data).then(res => res.data);
  }

  static pullMessage(taxWithholdCertId: string, data?: any): Promise<any> {
    return this.axios.put(`${this.entity}/${taxWithholdCertId}/pull-message`, data).then(res => res.data);
  }
}
